// extracted by mini-css-extract-plugin
export var gif = "_cl-0";